import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Information Technology landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. The route is gated by dept.it in allRoutes.js.
 */
const TOOLS = [
    "adminHub", "adminAccess", "adminUserPermissions", "adminEmployeeRoles", "epoLimits",
    "adminDepartments", "adminRoles", "support", "orgChart", "visitors",
];

const IT = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-server-line"
                        eyebrow="Infrastructure"
                        title="Information Technology"
                        subtitle="Systems, accounts, and infrastructure"
                        tone="violet"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Information Technology" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Admin shortcuts"
                        description="Access, roles, limits and support"
                        icon="ri-shield-user-line"
                    />
                    <DeptReportsGrid ids={[]} />

                    <ComingSoonCard
                        compact
                        icon="ri-server-line"
                        title="More for IT later"
                        message="Ideas for later: account provisioning requests, license tracking and a system health view. The cards above are live today."
                        tone="primary"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default IT;
